import { operationKeys } from 'hooks/queries/keys'
import type { InvalidationRule } from './types'

/**
 * Operation (super-admin) console rules. The realtime gateway fans
 * admin-relevant entity events to the `admin` room (see notification-service); this
 * maps each to the `operationKeys` (`['operation', ...]`) namespace.
 *
 * `operationKeys.all()` (`['operation']`) marks every ops query stale; React
 * Query only refetches the queries that are currently mounted, so a broad
 * invalidation on the dashboard refreshes just the dashboard widgets, and a
 * provider-detail view refreshes just that view. Payloads are env/provider
 * scoped in ways the socket does not always carry, so a coarse-but-correct root
 * invalidation is deliberate here.
 */
const opsAll = operationKeys.all()

export const operationRules: InvalidationRule[] = [
  { event: 'transaction:created', invalidate: [opsAll], debounceMs: 300 },
  { event: 'transaction:update', invalidate: [opsAll], debounceMs: 300 },
  { event: 'transaction:status-changed', invalidate: [opsAll], debounceMs: 300 },
  { event: 'customer:created', invalidate: [opsAll] },
  { event: 'customer:updated', invalidate: [opsAll] },
  { event: 'customer:deleted', invalidate: [opsAll] },
  { event: 'product:created', invalidate: [opsAll] },
  { event: 'product:updated', invalidate: [opsAll] },
  { event: 'product:deleted', invalidate: [opsAll] },
  { event: 'plan:created', invalidate: [opsAll] },
  { event: 'plan:updated', invalidate: [opsAll] },
  { event: 'plan:deleted', invalidate: [opsAll] },
  { event: 'purchase:created', invalidate: [opsAll] },
  { event: 'purchase:updated', invalidate: [opsAll] },
  { event: 'purchase:deleted', invalidate: [opsAll] },
]
